import { Button, CircularProgress } from "@mui/material";
import { CustomButtonProps } from "./types";
import { styles } from "./styles";
import React from "react";

export const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  onClick,
  icon,
  customStyles,
  loading,
  isSkipButton,
  isDisabled,
}) => {
  const renderIcon = () => {
    if (typeof icon === "string") {
      return <img src={icon} alt="icon" />;
    } else if (icon) {
      const IconComponent = icon;
      return <IconComponent />;
    }
    return null;
  };

  return (
    <Button
      disabled={isDisabled}
      sx={{
        ...(isSkipButton ? styles.skipButton : styles.button),
        ...customStyles,
      }}
      onClick={onClick}
    >
      {loading ? (
        <CircularProgress sx={{ color: "black" }} size={25} />
      ) : (
        <span style={styles.spanContainer}>
          {renderIcon()}
          {text}
        </span>
      )}
    </Button>
  );
};

export default CustomButton;
